// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-payslip.page.title': 'Payslips',
    'team-member-payslip.page.search_results': 'Search Results',
    'team-member-payslip.page.create.title': 'Create New Payslip',
    'team-member-payslip.page.search.title': 'Find Payslips',
    'team-member-payslip.page.edit.title': 'Edit Payslip',
    'team-member-payslip.page.view.title': 'View Payslip',
    'team-member-payslip.page.all': 'All',

    'team-member-payslip.button.cancel': 'Cancel',
    'team-member-payslip.button.select': 'Select',
    'team-member-payslip.button.find': 'Find Payslips',
    'team-member-payslip.button.search': 'Apply',
    'team-member-payslip.button.create': 'Save Payslip',
    'team-member-payslip.button.new': 'New Payslip',
    'team-member-payslip.button.save': 'Save Changes',
    'team-member-payslip.button.print': 'Print',
    'team-member-payslip.button.edit': 'Edit',
    'team-member-payslip.button.restore': 'Restore',
    'team-member-payslip.button.reset': 'Reset',

    'team-member-payslip.placeholder.search': 'Search payslips',

    'team-member-payslip.link.create_first_team_member_payslip': 'Click here to create your first payslip',
    'team-member-payslip.link.team_member_payslips': 'Return to Payslips',
    'team-member-payslip.link.retry': 'Click here to retry',

    'team-member-payslip.checkbox.all': 'Check All',
    'team-member-payslip.checkbox.actions_label': 'with selected',

    'team-member-payslip.label.team_member_name': 'Team Member',
    'team-member-payslip.label.earnings': 'Earnings',
    'team-member-payslip.label.deductions': 'Deductions',
    'team-member-payslip.label.net_pay': 'Net Pay',
    'team-member-payslip.label.ytd': 'Year To Date',
    'team-member-payslip.label.others': 'Other Information',
    'team-member-payslip.label.total': 'Total',
    'team-member-payslip.label.nis': 'NIS',
    'team-member-payslip.label.nht': 'NHT',
    'team-member-payslip.label.edtax': 'EdTax',
    'team-member-payslip.label.paye': 'PAYE',
    'team-member-payslip.label.pension': 'Pension',
    'team-member-payslip.label.taxable_gross': 'Taxable Gross',

    'team-member-payslip.label.total_currency_balance_in_cents': 'Balance In Cents',

    'team-member-payslip.label.from__cancelled_on': 'From cancelled on',
    'team-member-payslip.label.to__cancelled_on': 'To cancelled on',
    'team-member-payslip.label.cancelled_on': 'Cancelled On',

    'team-member-payslip.label.cancellation_reason': 'Cancellation Reason',

    'team-member-payslip.label.status': 'Status',

    'team-member-payslip.sort.field_label': 'Field',
    'team-member-payslip.sort.direction_label': 'Direction',
    'team-member-payslip.sort.direction_ascending': 'Ascending',
    'team-member-payslip.sort.direction_descending': 'Descending',

    'team-member-payslip.modal.title.team_member_payslip_print': 'Print Payslip',

    'team-member-payslip.modal.message.team_member_payslip_print': 'You are about to print this payslip | You are about to print these payslips',

    'team-member-payslip.success.message.team_member_payslip_created': 'Your payslip has been created',

    'team-member-payslip.error.message.error_loading_page': 'Sorry, there was an error loading payslip.| Sorry, there was an error loading payslips.',
};
